import { render, staticRenderFns } from "./TariffAutocomplete.vue?vue&type=template&id=4395c954&"
import script from "./TariffAutocomplete.vue?vue&type=script&lang=ts&"
export * from "./TariffAutocomplete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports